<template>
  <div class="header">
    <b-row class="header-row">
      <b-col cols="2" class="mui--text-left right">
        <img class="settings" src='http://images.mixd.tv/images/logo.png' />
        <!-- <svgicon icon="menu" height="34" color="#fff"></svgicon> -->
      </b-col>
      <b-col class="text-center" cols="8">mixd.tv - VoD QA Dashboard</b-col>
      <b-col class="left" cols="2">
        <small>Version 1.12</small>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import '../compiled-icons/menu'

export default {
  name: 'Header',
  data () {
    return {
      results: []
    }
  },
  mounted () {
    // axios.get('http://localhost:3000/getExports/')
    axios.get('http://vod-qa-dashboard.mixd.tv:3000/getExports/')
      .then(response => {
        this.results = response.data.collectionNames

        /* for (let idx in this.results) {
          this.results[idx].detailsLink = '/locationList/details/' + this.results[idx].entityId
        } */

        // response.data.msg.data
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: rgba(0,0,0,0.2);
  color: #fff;
  height: 50px;
  padding-top: 17px;
  padding-left: 5px;
  padding-right: 5px;
}
.header-row {
  margin: 0px;
}
.left {
  text-align: right;
}
.right {
  text-align: left;
}
.user {
  height: 25px;
}
.settings {
  height: 25px;
}
.text-center {
  font-weight: 400;
}
.city-link {
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue